import React, { Component } from 'react';
import _ from 'lodash';
import './Video.scss';

class Video extends Component {
  static defaultProps = {
    startTime: 0,
  };

  constructor(props) {
    super(props);

    this.togglePlay = this.togglePlay.bind(this);
  }

  componentDidMount() {
    const video = this.refs.video.getDOMNode();
    const { startTime } = this.props;

    if (startTime > 0) {
      video.addEventListener('loadedmetadata', () => {
        video.currentTime = startTime;
      });
    }

    // Parent events
    // eslint-disable-next-line no-unused-vars
    for (let name in this.props.events) {
      video.addEventListener(name, this.props.events[name]);
    }
  }

  componentWillReceiveProps(nextProps) {
    const video = this.refs.video.getDOMNode();

    // Parent events
    _.forEach(
      nextProps.events,
      function (fn, name) {
        if (fn !== this.props.events[name]) {
          video.addEventListener(name, nextProps.events[name]);
          video.removeEventListener(name, this.props.events[name]);
        }
      },
      this,
    );
    _.forEach(this.props.events, function (fn, name) {
      if (!(name in nextProps.events)) {
        video.removeEventListener(name, this.props.events[name]);
      }
    });
  }

  componentWillUnmount() {
    const video = this.refs.video.getDOMNode();

    // Parent events
    // eslint-disable-next-line no-unused-vars
    for (let name in this.props.events) {
      video.removeEventListener(name, this.props.events[name]);
    }
  }

  togglePlay() {
    const video = this.refs.video.getDOMNode();
    if (video.paused) {
      video.play();
    } else {
      this.refs.video.controls = true;
      video.pause();
    }
  }

  render() {
    const defaultProps = {
      controls: 'true',
      preload: 'auto',
      crossOrigin: 'anonymous',
    };
    // This overlay covers everything except the controls,
    // allowing both click-video-to-play in all browsers AND
    // preventing the click event from interfering with said controls.
    return (
      <div className="video_wrapper">
        <div className="video_overlay" onClick={this.togglePlay} />
        <video
          {...defaultProps}
          {...this.props}
          ref={(node) => (this.video = node)}
        />
      </div>
    );
  }
}

export default Video;
